import { api } from "./axios";

export type MembershipContext = {
  ministry_id: string;
  name: string;
  is_active: boolean;
  can_view: boolean;
  can_manage: boolean;
};

export type MembershipPeriod = {
  id: string;
  member_id: string;
  ministry_id: string;
  joined_at: string;
  left_at: string | null;
};

export const getMembershipContexts = (churchId: string) =>
  api.get<MembershipContext[]>(`/api/churches/${churchId}/authorization/membership-contexts`).then(response => response.data);

export async function getMemberMembershipPeriods(churchId: string, ministryId: string, memberId: string, signal?: AbortSignal) {
  const periods: MembershipPeriod[] = [];
  const limit = 500;
  for (let offset = 0; ; offset += limit) {
    const { data } = await api.get<MembershipPeriod[]>(
      `/api/churches/${churchId}/authorization/ministries/${ministryId}/memberships`,
      { params: { member_id: memberId, history: true, offset, limit }, signal },
    );
    periods.push(...data);
    if (data.length < limit) return periods;
  }
}
